<template>
  <div>
    <navbar-component />
    <div class="bg-container">
      <vendor-searchbar-layout :texts="texts"></vendor-searchbar-layout>
      <vendor-content-layout :texts="texts"></vendor-content-layout>
    </div>
    <footer-component />
    <whatsapp-component />

  </div>
</template>

<script>
export default {
  name: "VendorView",
  data() {
    return {
      //VARIABLES
      texts: "",
    };
  },
  beforeMount() {
    this.texts = FILE.vendor[this.selectLanguage];
  },
  computed: {
    selectLanguage: function () {
      return this.$store.state.language;
    },
  },
  watch: {
    selectLanguage: function () {
      if (this.selectLanguage) {
        this.texts = FILE.vendor[this.selectLanguage];
      }
    },
  },
};
</script>

<style scoped>
.bg-container {
  width: 100%;
  background: #f2f2f4 0% 0% no-repeat padding-box;
  opacity: 1;
  padding-top: 75px;
}
</style>